import { NgModule } from '@angular/core';
import { ProjectRoutingModule } from './project-routing.module';
import { AddprojectComponent } from '../addproject/addproject.component';
import { EditprojectComponent } from '../editproject/editproject.component';
import { ProjectlistComponent } from './projectlist.component';
import { ProjectdetailsComponent } from '../projectdetails/projectdetails.component';
import { SharedModule } from '../../../shared/shared.module';

@NgModule({
  declarations: [
    ProjectlistComponent,
    AddprojectComponent,
    EditprojectComponent,
    ProjectdetailsComponent
  ],
  imports: [
    ProjectRoutingModule,
    SharedModule
  ]
})

export class ProjectModule {}
